import { useRef } from 'react';
import { ethers } from 'ethers';

type AddressProvider = {
  address: string | undefined;
  providerOrSigner: ethers.Provider | ethers.Signer | undefined;
};

export function useAddressProvider(
  address: string | undefined,
  providerOrSigner: ethers.Provider | ethers.Signer | undefined,
): AddressProvider {
  const addressProvider = useRef<AddressProvider>({
    address: undefined,
    providerOrSigner: undefined,
  });

  if (!providerOrSigner) {
    addressProvider.current = {
      address: undefined,
      providerOrSigner: undefined,
    };
  }

  if (
    (address !== addressProvider.current.address &&
      (providerOrSigner !== addressProvider.current.providerOrSigner ||
        addressProvider.current.providerOrSigner !== undefined)) ||
    (addressProvider.current.providerOrSigner instanceof
      ethers.AbstractProvider &&
      providerOrSigner instanceof ethers.AbstractSigner)
  ) {
    addressProvider.current = { address, providerOrSigner };
  } else if (
    address !== addressProvider.current.address &&
    addressProvider.current.providerOrSigner !== undefined &&
    providerOrSigner === addressProvider.current.providerOrSigner
  ) {
    addressProvider.current = { ...addressProvider.current, address };
  }

  return addressProvider.current;
}
